import 'settings/i18n';
import React from 'react';
import { hydrate, render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'store';

import InitialAnimation from 'components/organisms/InitialAnimation';
import * as serviceWorker from './serviceWorker';
import './index.css';
import 'focus-visible';
import App from './App';

function hashLinkScroll() {
  const { hash } = window.location;
  if (hash !== "") {
    setTimeout(() => {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 210);
  }
}

const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
  hydrate(
    <React.StrictMode>
      <BrowserRouter onUpdate={hashLinkScroll}>
        <Provider store={store}>
          <InitialAnimation />
          <div className="js-focus-visible focus-visible">
            <App />
          </div>
        </Provider>
      </BrowserRouter>
    </React.StrictMode>,
    rootElement,
  );
} else {
  render(
    <React.StrictMode>
      <BrowserRouter onUpdate={hashLinkScroll}>
        <Provider store={store}>
          <InitialAnimation />
          <div className="js-focus-visible focus-visible">
            <App />
          </div>
        </Provider>
      </BrowserRouter>
    </React.StrictMode>,
    rootElement,
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
